const prefix = 'SourcingProjectRequest';

export enum SourcingProjectRequestField {
  SOURCING_PROJECT_PROPOSAL_ITEM_ID = `${prefix}.sourcingProjectProposalItemId`,
  SOURCING_PROJECT_LOT_ITEM = `${prefix}.sourcingProjectLotItem`,
  SOURCING_PROJECT_ID = `${prefix}.sourcingProjectId`,
  SOURCING_PROJECT_LOT_ID = `${prefix}.sourcingProjectLotId`,
  LATEST_ROUND_NUMBER = `${prefix}.latestRoundNumber`,
  LOT_ITEM_ID = `${prefix}.lotItemId`,
  LOT_ITEM_TITLE = `${prefix}.lotItemTitle`,
  LOT_ITEM_DESCRIPTION = `${prefix}.lotItemDescription`,
  LOT_ITEM_UNIT = `${prefix}.lotItemUnit`,
  LOT_TITLE = `${prefix}.lotTitle`,
  POSITION = `${prefix}.position`,
  PRICE_PER_UNIT = `${prefix}.pricePerUnit`,
  CURRENCY = `${prefix}.currency`,
  ROUND_NUMBER = `${prefix}.roundNumber`,
  QUANTITY = `${prefix}.quantity`,
  SUPPLIERS = `${prefix}.suppliers`,
  STATUS = `${prefix}.status`,
}

export enum SourcingProjectRequestSegment {
  AWARDED = `${prefix}.awarded`,
  LATEST_ROUND = `${prefix}.latestRound`,
}

export interface SourcingProjectRequestData {
  sourcingProjectProposalItemId: string;
  sourcingProjectLotItem: string;
}
